import {Directive} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Directive({
  selector: '[siAccessibilityDialog]'
})
export class AccessibilityDialogDirective {

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.setAriaLabels()
  }

  setAriaLabels(): void {
    setTimeout(() => {
      const closeButton = document.querySelector('.p-dialog-header-close');
      if (closeButton) {
        closeButton.setAttribute('aria-label', this.translateService.instant('SI_CLOSE'));
      }
    }, 10);
  }

}
